import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const MarkdownBlockquote = ({ children, kind }) => {
  const isDefault = kind === 'default';
  const isCompact = kind === 'compact';

  return (
    <blockquote
      className={cx('md-blockquote', {
        'text-center m-y-2 color-orange h1 flexbox md-blockquote--default':
          isDefault,
        'm-t-1 m-b-2 color-danger p-x-3 p-x-0-mobile md-blockquote--compact':
          isCompact,
      })}
    >
      <div
        className={cx('md-blockquote__quote', {
          'md-blockquote__quote--default': isDefault,
          'md-blockquote__quote--compact': isCompact,
        })}
      >
        <span
          className={cx('md-blockquote__char', {
            'color-base-light md-blockquote__char--open': isDefault,
            'md-blockquote__char--compact': isCompact,
          })}
        >
          {'\u201c'}
        </span>
      </div>
      {children}
      {isDefault && (
        <div className="md-blockquote__quote md-blockquote__quote--default align-self-flex-end">
          <span className="color-base-light md-blockquote__char md-blockquote__char--close">
            {'\u201d'}
          </span>
        </div>
      )}
    </blockquote>
  );
};

MarkdownBlockquote.defaultProps = {
  kind: 'default',
};

MarkdownBlockquote.propTypes = {
  children: PropTypes.node.isRequired,
  kind: PropTypes.oneOf(['default', 'compact']),
};

export { MarkdownBlockquote };
